import { Box, CircularProgress } from '@mui/material';
import { FC } from 'react';
import { useVideoCall } from '../../../contexts/videoCall/context';
import { MeetingStatus, MeetingUserType } from '../../../lib/appointments/types';
import EnaraHeader from './EnaraHeader';
import MeetingEndsView from './MeetingEndsView';
import ParticipantVideoPreview from './ParticipantVideoPreview';
import Tips from './Tips';
import styles from './WaitingRoom.module.css';

const WaitingRoom: FC = () => {
  const { videoCallState } = useVideoCall();
  const { videoPreview } = videoCallState;

  return (
    <Box className={styles.waitingRoomContainer}>
      <EnaraHeader />

      <div className={styles.mainContent}>
        {!videoPreview ? (
          <CircularProgress
            style={{
              alignSelf: 'center',
            }}
          />
        ) : videoPreview.appointment.meetingStatus === MeetingStatus.Finished ? (
          <MeetingEndsView />
        ) : (
          <>
            <ParticipantVideoPreview />
            {videoPreview?.currentParticipant.userType === MeetingUserType.Attendant && <Tips />}
          </>
        )}
      </div>
    </Box>
  );
};

export default WaitingRoom;
